import React, {FC} from 'react'
import {Text, TextButton, TextTypography} from 'wix-ui-tpa/cssVars'

import type {CancellationFeeWarning} from '../../../../utils/cancellationFeeWarning'
import {getFeeWarningKey} from '../../../../utils/cancellationFeeWarning'
import {cancelModalDataHooks} from '../CancelModal/constants'

import {st, classes} from './styles.st.css'

type FeeWarning = Pick<
  CancellationFeeWarning,
  'isPerGuestFee' | 'formattedTotal' | 'formattedPerGuest' | 'savedCard' | 'guestPolicy'
>

interface Props {
  t: (key: string, options?: Record<string, unknown>) => string
  feeWarning: FeeWarning
  className?: string
  noticeDataHook?: string
  viewPolicyDataHook?: string
  onViewPolicy?: () => void
}

export const CancellationFeeNotice: FC<Props> = ({
  t,
  feeWarning,
  className,
  noticeDataHook = cancelModalDataHooks.feeNotice(),
  viewPolicyDataHook = cancelModalDataHooks.viewPolicyLink(),
  onViewPolicy,
}) => {
  const {isPerGuestFee, formattedTotal, formattedPerGuest, savedCard, guestPolicy} = feeWarning
  const feeWarningKey = getFeeWarningKey(isPerGuestFee, Boolean(savedCard?.last4))

  return (
    <div className={st(classes.feeNotice, className)} data-hook={noticeDataHook}>
      <Text typography={TextTypography.listText} tagName="p" className={classes.feeNoticeText}>
        {t(feeWarningKey, {
          price: formattedTotal,
          price_per_guest: formattedPerGuest,
          total: formattedTotal,
          perGuest: formattedPerGuest,
          cardBrand: savedCard?.brand,
          last4: savedCard?.last4,
        })}{' '}
        {guestPolicy && onViewPolicy ? (
          <TextButton
            className={classes.viewPolicyLink}
            onClick={onViewPolicy}
            data-hook={viewPolicyDataHook}
          >
            {t('uou-reservations.reservation-confirmation.cancel-fee-warning.view-policy')}
          </TextButton>
        ) : null}
      </Text>
    </div>
  )
}

export default CancellationFeeNotice
